// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#0B2353',
        employeePrimary: '#3F51B5',
        indigo: '#3F51B5',
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: '#f97316',
        error: colors.deepOrange.accent4,
        success: colors.green.accent3,
        navigationColor: '#0B2353',
        appBarColor: '#0B2353',
        cardColor: '#2A2A2A',
        backGroundColor: '#1F1F1F',
        sideNavColor: '#0B2353'
      },
      light: {
        primary: '#0B2353',
        employeePrimary: '#3F51B5',
        indigo: '#3F51B5',
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: '#f97316',
        error: colors.deepOrange.accent4,
        success: colors.green.accent4,
        navigationColor: '#0B2353',
        appBarColor: '#0B2353',
        cardColor: '#FFFFFF',
        backGroundColor: '#F3F7FF',
        sideNavColor: '#0B2353'
      }
    },
    dark: false // Set to true if you want the dark theme by default
  },
  treeShake: true
})
